import { component as defineComponent, utils } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function MegaDrawer() {
    this.defaultAttrs({
        form: 'form',
        input: '[data-mega-drawer-filter-input]',
        toggle: '[data-mega-drawer-toggle]',
        tab: '[data-mega-drawer-tab-name]',
        panel: '[data-mega-drawer-panel-name]',
        panelClose: '[data-mega-drawer-close-panel-button]',
        panelDefault: '[data-mega-drawer-panel-default]',
        clearAllFilters: '[data-mega-drawer-clear-filters]',
        currentPage: '[data-current-page]',

        checkbox: 'input[type=checkbox]',
        radioButton: 'input[type=radio]',

        defaultTab: '',
        defaultURL: '',
    });

    this.after('initialize', function() {
        this.on('click', {
            toggle: this.toggleMegaDrawer,
            tab: this.tabClick,
            clearAllFilters: this.clearAllFilters,
            panelClose: this.deactivateTabs,

            input: this.selectFilter,
        });

        this.on('uiOpenMegaDrawer', this.openMegaDrawer);
        this.on(document, 'uiCloseMegaDrawer', this.closeMegaDrawer);
        this.on(document, 'uiBodyClick', this.bodyClick);
        this.on(document, 'uiMegaDrawerToggleDefault', this.toggleDefaultTab);
        this.on(document, 'uiMegaDrawerTogglePanel', this.toggleTab);
        this.on(document, 'uiMegaDrawerOpenPanel', this.openTab);

        this.initFilters();

        this.on(document, 'dataFilterChange', this.filtersUpdate);
        this.on('uiTagFilterSelected', this.tagAdded);
        this.on('uiTagFilterDeleted', this.tagRemoved);
        this.on(document, 'uiPaginationChangePage', this.changePage);
        this.on(document, 'dataNeedsFilterTitles', this.addFilterTitlesToFilterData);
        this.on(document, 'uiHideUnlikedDesign', this.hideUnlikedDesign);
    });

    // Filter UI CRUD

    this.initFilters = function() {
        this.trigger('uiInitFilters', { filters: this.getCurrentFiltersArray() });
    };

    this.emitFilters = function() {
        this.trigger('uiAddFilters', { filters: this.getCurrentFiltersArray() });
    };

    this.getCurrentFiltersArray = function() {
        if (this.select('form').length) {
            const formArray = this.select('form').serializeArray();
            formArray.forEach((el, index) => {
                const $input = $($(`[name="${el.name}"][value="${el.value}"]`)[0]);
                const inputTitle = $input.attr('data-mega-drawer-filter-title');
                if (inputTitle) {
                    formArray[index].title = inputTitle;
                }
            });
            return formArray;
        }
        return null;
    };

    this.filtersUpdate = function(event, data) {
        // FIXME: Rewrite using Object.keys
        for (const filtersIndex in data.filters) {
            // eslint-disable-line
            const filter = data.filters[filtersIndex];
            if (data.filters.hasOwnProperty(filtersIndex)) {
                // eslint-disable-line
                this.updateFilter({
                    name: filtersIndex,
                    filterItems: filter,
                });
            }
        }
        this.updateClearAllFiltersButton(data.filters);
    };

    this.updateFilter = function(filter) {
        const inputs = this.getInputsByName(filter.name);
        inputs.prop('checked', false);

        if (Array.isArray(filter.filterItems)) {
            filter.filterItems.forEach(filterItem => {
                inputs.filter(`[value="${filterItem.value}"]`).prop('checked', true);
            });
        } else {
            const value =
                filter.filterItems !== undefined ? filter.filterItems.value : filter.filterItems;
            inputs.filter(`[value="${value}"]`).prop('checked', true);
        }
    };

    this.getInputsByName = function(name) {
        return this.select('form').find(`[name="${name}"]`);
    };

    this.selectFilter = utils.debounce(function(event, data) {
        if (data.el.checked) {
            this.trigger('uiAddFilters', {
                filters: [
                    {
                        name: data.el.name,
                        title: $(data.el).attr('data-mega-drawer-filter-title'),
                        value: data.el.value,
                    },
                ],
            });
        } else {
            this.trigger('uiRemoveFilters', {
                filters: [
                    {
                        name: data.el.name,
                        title: $(data.el).attr('data-mega-drawer-filter-title'),
                        value: data.el.value,
                    },
                ],
            });
        }
    }, 200);

    this.tagAdded = function(event, data) {
        this.trigger('uiAddFilters', {
            filters: [
                {
                    name: data.filterName,
                    title: data.tagName,
                    value: data.tagName,
                },
            ],
        });
    };

    this.tagRemoved = function(event, data) {
        this.trigger('uiRemoveFilters', {
            filters: [
                {
                    name: data.filterName,
                    value: data.tagName,
                },
            ],
        });
    };

    this.updateClearAllFiltersButton = function(filters) {
        let filtersActive = false;

        // FIXME: Rewrite using Object.keys
        for (const filter in filters) {
            // eslint-disable-line
            if (filters.hasOwnProperty(filter)) {
                // eslint-disable-line
                if (filter !== 'page' && filters[filter]) {
                    filtersActive = true;
                }
            }
        }

        const clearAllFiltersButton = this.select('clearAllFilters');
        if (filtersActive) {
            clearAllFiltersButton.attr('data-active', 'true');
        } else {
            clearAllFiltersButton.attr('data-active', 'false');
        }
    };

    this.clearAllFilters = function() {
        this.trigger('uiRemoveAllFilters');
    };

    this.changePage = function(event, data) {
        this.trigger('uiAddFilters', {
            filters: [
                {
                    name: 'page',
                    value: data.page.toString(),
                },
            ],
        });
    };

    this.getFilterTitleByNameAndValue = function(name, value) {
        const $input = this.getInputsByName(name).filter(`[value="${value}"]`);
        return $input.attr('data-mega-drawer-filter-title') || $input.val();
    };

    this.addTitlesToFilterArray = function(filter, filterName) {
        const filterWithTitles = [];
        filter.forEach(function(filterValue) {
            const value = filterValue.value;
            const title = this.getFilterTitleByNameAndValue(filterName, value);
            filterWithTitles.push({
                value,
                title: title || value,
            });
        }, this);
        return filterWithTitles;
    };

    this.addTitleToFilter = function(filter, filterName) {
        const value = filter.value;
        const title = this.getFilterTitleByNameAndValue(filterName, value);
        return {
            value,
            title,
        };
    };

    this.addFilterTitlesToFilterData = function(event, data) {
        const filters = data.filters;
        const filtersWithTitles = {};

        // FIXME: Rewrite using Object.keys
        for (const filterName in filters) {
            // eslint-disable-line
            const filter = filters[filterName];
            if ($.isArray(filter)) {
                filtersWithTitles[filterName] = this.addTitlesToFilterArray(filter, filterName);
            } else if (filter.value) {
                filtersWithTitles[filterName] = this.addTitleToFilter(filter, filterName);
            } else {
                filtersWithTitles[filterName] = { value: '' };
            }
        }
        this.trigger('uiHasFilterTitles', { filters: filtersWithTitles });
    };

    // Open and close drawers/panels/etc

    this.openTab = function(category) {
        this.activateTab(category);
        this.openMegaDrawer();
    };

    this.toggleTab = function(event, data) {
        if (this.select('toggle').attr('data-active') === 'true') {
            const $panel = this.$node.find(`[data-mega-drawer-panel-name="${data.category}"]`);
            if ($panel.attr('data-active') === 'true') {
                this.closeMegaDrawer();
            } else {
                this.activateTab($panel.attr('data-mega-drawer-panel-name'));
            }
        } else {
            this.openTab(data.category);
        }
    };

    this.bodyClick = function(event, data) {
        if (!this.$node.is(data.target) && this.$node.has(data.target).length === 0) {
            this.closeMegaDrawer();
        }
    };

    this.toggleMegaDrawer = function() {
        if (this.$node.attr('data-active') === 'true') {
            this.closeMegaDrawer();
        } else {
            this.openMegaDrawer();
        }
    };

    this.tabClick = function(event, data) {
        this.activateTab($(data.el).attr('data-mega-drawer-tab-name'));
    };

    this.activateTab = function(tabName) {
        if (this.doesPanelExist(tabName)) {
            this.select('tab').attr('data-active', 'false');
            this.select('tab')
                .filter(`[data-mega-drawer-tab-name="${tabName}"]`)
                .attr('data-active', 'true');
            this.select('panel').attr('data-active', 'false');
            this.select('panel')
                .filter(`[data-mega-drawer-panel-name="${tabName}"]`)
                .attr('data-active', 'true');
        }
    };

    this.doesPanelExist = function(tabName) {
        return !!this.select('panel').filter(`[data-mega-drawer-panel-name="${tabName}"]`).length;
    };

    this.toggleDefaultTab = function() {
        if (this.attr.defaultTab) {
            this.activateTab(this.attr.defaultTab);
        }
        this.toggleMegaDrawer();
    };

    this.deactivateTabs = function() {
        this.select('tab').attr('data-active', 'false');
        this.select('panel').attr('data-active', 'false');
    };

    this.openMegaDrawer = function() {
        this.select('toggle').attr('data-active', 'true');
        this.$node.attr('data-active', 'true');
    };

    this.closeMegaDrawer = function() {
        this.select('toggle').attr('data-active', 'false');
        this.$node.attr('data-active', 'false');
    };

    this.hideUnlikedDesign = function() {
        const yourLikesToggle = this.getInputsByName('your-likes');

        if (yourLikesToggle.prop('checked')) {
            this.trigger('uiNeedsBrowseDesigns', { preventScrollTop: true, hideSpinner: true });
        }
    };
}

export default defineComponent(MegaDrawer);



// WEBPACK FOOTER //
// ./src/js/component_ui/mega-drawer.js